export const getEncodedAttributeName = (attributeName: string) =>
  `custom_attr_${btoa(encodeURIComponent(attributeName))}`;
